module.exports = __webpack_public_path__ + "static/media/prod_10000_snack.104d5598.jpg";